import { DatePicker } from 'antd';

interface DateTimeMapProps {
  disabled: boolean;
}

export const DateTimeMap = ({ disabled, ...restProps }: DateTimeMapProps) => {
  return <DatePicker showTime disabled={disabled} {...restProps} />;
};
